import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app__content" }
const _hoisted_2 = { class: "app__title d-flex align-center" }
const _hoisted_3 = { class: "app__title-heading" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-center justify-center h-full"
}
const _hoisted_5 = {
  key: 0,
  class: "d-block text-small"
}

import { computed, onMounted, onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { ISnackBar } from '@/types/store';

// #constants

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const { commit, dispatch, getters } = useStore();

// #computed
const title = computed<string>(() => {
  return getters['getAssetTitle'];
});
const userEmail = computed<string | null>(() => {
  return getters['getUserEmail'];
});
const snackbar = computed<ISnackBar>(() => {
  return getters['getSnackBar'];
});

// #methods
const onClose = (): void => {
  dispatch('close');
};
const closeSnackbar = () => {
  commit('closeSnackbar');
};
const setCredentials = (credentials: { [x: string]: string }) => {
  Object.keys(credentials).forEach((key) => {
    localStorage.setItem(key, credentials[key]);
  });

  dispatch('fetchUserInfo');
};

// #hooks
onMounted(() => {
  window.addEventListener('message', (ev) => {
    const action = ev?.data?.action;
    if (action === 'credentials') {
      setCredentials(ev.data.data);
    } else if (action === 'auction-info') {
      commit('setAssetInfo', ev.data.data);
      router.push('/bid');
    } else if (action === 'time-diff') {
      commit('setTimeDiff', ev.data.data.diff);
    }
  });
});
onBeforeMount(() => {
  dispatch('initSync');
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "app" }, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"text-align":"center","color":"red","font-weight":"bold","margin-bottom":"10px"} }, null, -1)),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          (userEmail.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: onClose
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        class: "mr-6",
                        size: "32",
                        color: "#154A6B"
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-arrow-left", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("h3", _hoisted_3, _toDisplayString(title.value), 1)
                ]),
                _createVNode(_component_v_main, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "48",
                  color: "#18A1C8"
                })
              ])),
          _createVNode(_component_v_snackbar, {
            modelValue: snackbar.value.isOpened,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((snackbar.value.isOpened) = $event)),
            timeout: 5000,
            bottom: "",
            color: snackbar.value.color
          }, {
            actions: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: closeSnackbar
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(snackbar.value.text) + " ", 1),
              (snackbar.value.subtext)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(snackbar.value.subtext), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "color"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})